import { util } from "@sa-team/kotlin-commuter-sdk";
import { container, DependencyToken, EventType } from "core.app";

export function startRemoveSplashScreen(): void {
  const eventBus = container.get({ token: DependencyToken.EventBus });

  // Select the first event and remove the Android splash screen when the app
  // has beagn to startup.
  const subscription = eventBus
    .getByType$({ type: EventType.StartUp })
    .subscribe(() => {
      try {
        util.ready();
        subscription.unsubscribe();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn("Could not call ready() on KC-SDK");
      }
    });
}

export default startRemoveSplashScreen;
